export default "__VITE_ASSET__CCYHd$P7__"